module.exports = __webpack_public_path__ + "static/protetyka-a66ea240e55d0089965c7b8de2630676.svg";